/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import Plaatjie from '@ubo/plaatjie'

// Libraries
import parse from 'html-react-parser'

// Language
import { getLanguage } from 'services/language'

// Elements
import BlockDefault from 'components/elements/BlockDefault'
import ButtonDefault from 'components/elements/ButtonDefault'
import HeroDefault from 'components/elements/HeroDefault'
import BackgroundDescription from 'components/elements/BackgroundDescription'
// import RatingAlt from 'components/Reviews/RatingAlt'
import ParseContent from 'components/shared/ParseContent'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
// import NationsSeeker from 'components/NationsSeeker'
import Identity from 'components/Identity'
// import Review from 'components/Review'
// import Gallery from 'components/Gallery'
import ButtonSecondary from 'components/elements/ButtonSecondary'
import styled from 'styled-components'
import GravityForm from 'components/GravityForm'

// Elements
import ImageBackground from 'components/elements/ImageBackground'

const StyledHeroDefault = styled(HeroDefault)`
  @media (max-width: 991px) {
    min-height: 560px !important;
    max-height: 560px !important;
  }
`

const Description = styled.div`
  & p {
    line-height: 30px;
    font-weight: ${(props) => props.theme.font.weight.s};
  }
`

const BackgroundImageBackground = styled(ImageBackground)`
  position: absolute !important;
  height: 1150px;
  width: 1600px;
  top: 0;
  right: 0;
  z-index: 0;

  @media (max-width: 991px) {
    height: 600px;
  }
`

const List = styled.ul`
  list-style: none;
  margin-left: -1.7rem;

  & li {
    font-size: ${(props) => props.theme.font.size.xm};
    line-height: 40px;
    font-weight: 300;

    @media (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size['18']};
      line-height: 35px;
    }
  }

  & li:before {
    content: '';
    background-color: ${(props) => props.theme.color.contrast};
    border-radius: 50%;
    font-weight: bold;
    display: inline-block;
    width: 10px;
    height: 10px;
    font-size: 24px;
    margin-left: -0.5em;
    margin-right: 0.5em;
  }
`

const DescriptionContainer = styled.div`
  min-height: 350px;
`

const StyledBlockDefault = styled(BlockDefault)`
  padding-bottom: 0 !important;
`

const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;
`

const BrochureSection = styled.section`
  @media (min-width: 992px) {
    min-height: 1150px;
  }
`

const ImageBlock = styled.div`
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  font-size: 0;
  border-radius: 25px;
  background-color: #e1e1e1;
  width: 100%;
  outline: none;
  overflow: hidden;
  position: relative;

  & > div {
    position: absolute !important;
    top: 0;
    left: 0;
  }

  @media (min-width: 992px) {
    padding-top: ${(props) => (props.height ? props.height : 50)}%;
  }

  @media (max-width: 991px) {
    padding-top: 50%;
  }

  /* &:hover {
    border: 3px solid ${(props) => props.theme.color.contrast};
  } */
`
const EmployeeBlock = styled.div`
  background-color: ${(props) => props.theme.color.contrast};
  border-radius: 25px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
`

const EmployeeDescription = styled(ParseContent)`
  color: ${(props) => props.theme.color.text.light};
  font-size: ${(props) => props.theme.font.size.m};

  & h3 {
    font-size: ${(props) => props.theme.font.size.xl};

    @media (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.xm};
    }

    @media (max-width: 450px) {
      font-size: 16px;
    }
  }

  & p {
    text-align: left;
    line-height: 35px;
    font-size: ${(props) => props.theme.font.size.m};

    & strong {
      font-weight: ${(props) => props.theme.font.weight['700']};
    }
  }
`

// const EmployeeImage = styled(ImageBackground)`
//   height: 250px;
//   width: 200px;
//   margin-top: -50px;
// `

const DownloadBrochure = styled.section`
  @media (min-width: 992px) {
    min-height: 474px;
  }
`

const BrochureImage = styled(Plaatjie)`
  position: absolute;
  width: 911px;
  left: -46px;
  top: -90px;
`

const BrochureText = styled(ParseContent)`
  & h2 {
    margin-bottom: 2rem;
  }

  p {
    color: ${(props) => props.theme.color.text.light};
  }
`

const Left = styled.div``

const StyledButtonSecondary = styled(ButtonSecondary)`
  position: absolute;
  top: -34px;

  > div {
    font-size: 16px;
    padding: 12px 25px;
  }
`

const Right = styled.div`
  @media (min-width: 992px) {
    margin-bottom: -160px !important;
  }
`

const EmployeeDescriptionBlock = styled.div`
  @media (min-width: 992px) {
    width: 601px;
  }

  @media (max-width: 991px) {
    width: 90%;
  }
`

const ContactBlock = styled(BlockDefault)`
  background-color: ${(props) => props.theme.color.contrast};
  color: ${(props) => props.theme.color.text.light};
`

const SalesImage = styled(ImageBackground)`
  width: 799px;
  height: 340px;
  margin-top: -104px;

  @media (max-width: 991px) {
    width: 100%;
    height: 250px;
  }

  @media (max-width: 450px) {
    height: 150px;
    margin-top: -80px;
  }
`

const Tekst = styled.p`
  font-size: ${(props) => props.theme.font.size[18]};
  color: #fff;
  font-weight: 900;
`

const CustomImageBlockContainer = styled.div`
  margin-top: -300px;
`

const PageTemplate = ({
  data: {
    page: { path, acf, yoast_meta: yoast },
  },
}) => {
  const language = getLanguage()

  return (
    <Layout>
      <SEO yoast={yoast} path={path} />

      <section>
        <StyledHeroDefault
          image={acf.banner.image}
          hideOverlay
          big
          home
          rounded={false}
        >
          <div className="d-flex align-items-end justify-content-start h-100">
            <div className="w-100 mb-n5 mb-md-0">
              <div className="row">
                <div className="col-lg-8 mb-n5">
                  <BlockDefault className="mb-n5" bigBorderRadius>
                    <div>{parse(acf.banner.title)}</div>
                    <Description className="mt-2 mt-lg-4">
                      {parse(acf.banner.description)}
                    </Description>
                    <div className="mt-4 text-center d-flex flex-wrap justify-content-between align-items-center">
                      <ButtonDefault
                        type="next"
                        to={acf.banner.cta.button_one.url}
                        className="mb-3 mb-xl-0"
                      >
                        {acf.banner.cta.button_one.title}
                      </ButtonDefault>
                      <ButtonSecondary
                        type="next"
                        to={acf.banner.cta.button_two.url}
                      >
                        {acf.banner.cta.button_two.title}
                      </ButtonSecondary>
                    </div>
                  </BlockDefault>
                </div>
              </div>
            </div>
          </div>
        </StyledHeroDefault>
      </section>

      <BrochureSection>
        <div className="container">
          <div className="row">
            <div className="col-lg-8 position-relative">
              <BackgroundImageBackground
                style={{
                  backgroundSize: 'contain',
                  backgroundPosition: 'right center',
                }}
                src={acf.brochure.image}
              />
            </div>
          </div>
        </div>

        <DescriptionContainer className="container mt-5 pt-4 pt-lg-1">
          <BackgroundDescription
            className="mt-5 pt-5 mt-lg-3"
            content={acf.brochure.backgroundtext}
          />
        </DescriptionContainer>

        <div className="container pb-5">
          <div className="row">
            <div className="col-lg-5" />
            <div className="col-lg-7">
              <StyledBlockDefault bigBorderRadius>
                <ParseContent className="mb-4" content={acf.brochure.title} />
                <List className="mb-4 pb-2">
                  {acf.brochure.usps.map(({ item }) => (
                    <li>{item}</li>
                  ))}
                </List>
                <ButtonDiv>
                  <ButtonDefault
                    type="next"
                    className="mb-n3"
                    to={acf.brochure.button.url}
                  >
                    {acf.brochure.button.title}
                  </ButtonDefault>
                </ButtonDiv>
              </StyledBlockDefault>
            </div>
          </div>
        </div>
      </BrochureSection>

      <section>
        <div className="container pt-lg-5 pb-lg-4">
          <div className="row pt-4 pt-lg-5 pb-4 pb-lg-0">
            <div className="col-lg-7">
              <BlockDefault bigBorderRadius>
                <ParseContent className="mb-4" content={acf.benefits.title} />
                <List className="mb-0 pb-2">
                  {acf.benefits.usps.map(({ item }, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <li key={index}>{item}</li>
                  ))}
                </List>
              </BlockDefault>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row pb-5">
            <div className="col-lg-7 d-flex flex-wrap">
              <div className="col-lg-2 d-none d-lg-block" />
              <div className="col-lg-10 px-0 px-lg-3 mb-4 mb-lg-0">
                <ImageBlock role="button" tabIndex="0" height="80">
                  <Plaatjie
                    className="h-100 w-100"
                    image={acf.benefits.image_left}
                  />
                </ImageBlock>
              </div>
            </div>
            <div className="col-lg-5 mt-lg-n5 px-0">
              <CustomImageBlockContainer className="col-lg-9">
                <ImageBlock role="button" tabIndex="0" height="140">
                  <Plaatjie
                    className="h-100 w-100"
                    image={acf.benefits.image_right}
                  />
                </ImageBlock>
              </CustomImageBlockContainer>
              <div className="col-lg-3" />
              <div className="col-lg-12 pt-5">
                <BlockDefault bigBorderRadius>
                  <ParseContent className="mb-4" content={acf.cta.title} />
                  <List className="mb-0 pb-2">
                    {acf.cta.upss.map(({ item }, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <li key={index}>{item}</li>
                    ))}
                  </List>
                </BlockDefault>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="row pb-5">
            <div className="col-12 col-lg-8">
              <EmployeeBlock className="w-100 mt-5">
                <div className="d-flex flex-wrap justify-content-center mb-2">
                  <SalesImage
                    src={acf.cta.image}
                    style={{ backgroundSize: 'contain' }}
                    className="mb-2 mb-sm-4"
                  />
                  <EmployeeDescriptionBlock className="d-flex justify-content-between align-items-center">
                    {acf.cta.persons.person.map(({ description }, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <EmployeeDescription content={description} key={index} />
                    ))}
                  </EmployeeDescriptionBlock>
                </div>
                <Tekst className="pt-2 px-4 mx-3">
                  {language === 'nl_NL' ? (
                    <span>Ons partner sales team</span>
                  ) : (
                    <span>Our partner sales team</span>
                  )}
                </Tekst>
                <div className="position-relative d-flex justify-content-start mt-5 mx-3 px-3">
                  <StyledButtonSecondary
                    type="next"
                    to={acf.cta.persons.button.url}
                  >
                    {acf.cta.persons.button.title}
                  </StyledButtonSecondary>
                </div>
              </EmployeeBlock>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container pt-4 pb-lg-5 mb-lg-3">
          <BackgroundDescription
            content={acf.identity.background_description}
          />
        </div>
      </section>

      <section className="pt-lg-5">
        <div className="container mt-lg-5 mb-5 pt-lg-5">
          <Identity fields={acf.identity} />
        </div>
      </section>

      <section id="brochure">
        <div className="container pt-4 pb-lg-5 mb-lg-5">
          <BackgroundDescription
            className="mb-lg-5 pb-lg-5"
            content={acf.download_brochure.backroundtext}
          />
        </div>
      </section>

      <DownloadBrochure className="my-lg-5 color-background-background">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-lg-6 py-5">
              <BrochureText
                className="mb-4"
                content={acf.download_brochure.description}
              />
              <GravityForm
                brochure
                vacature
                id={language === 'nl_NL' ? 14 : 15}
              />
            </div>
            <div className="col-lg-6 position-relative d-none d-lg-block">
              <BrochureImage image={acf.download_brochure.image_brochure} />
            </div>
          </div>
        </div>
        {/* <a id="contact" /> */}
      </DownloadBrochure>

      <section>
        <div className="container">
          <div className="row py-5 align-items-start">
            <Left className="col-lg-6 mb-lg-5">
              <BlockDefault bigBorderRadius>
                <ParseContent content={acf.contact.title} />
                <GravityForm id={language === 'nl_NL' ? 1 : 4} />
              </BlockDefault>
            </Left>
            <Right className="col-lg-6">
              <ContactBlock className="mt-5 mt-lg-0" bigBorderRadius>
                <ParseContent content={acf.contact.contactdetails} />
              </ContactBlock>
            </Right>
          </div>
        </div>
      </section>

      <section>
        <div className="container pt-5 pb-lg-5 mb-lg-5">
          <BackgroundDescription
            className="mb-lg-5 pb-lg-5"
            content={acf.maps.backgroundtekst}
          />
        </div>
      </section>

      <section>
        <div className="container pb-lg-5">
          <div className="row py-5">
            <div className="col-12">
              <Plaatjie className="w-100 h-100" image={acf.maps.image} />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default PageTemplate

// eslint-disable-next-line no-undef
export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      title
      path
      acf {
        banner {
          title
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 2000)
              }
            }
          }
          description
          cta {
            button_one {
              title
              url
            }
            button_two {
              title
              url
            }
          }
        }

        brochure {
          backgroundtext
          title
          usps {
            item
          }
          button {
            title
            url
          }
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }

        benefits {
          title
          usps {
            item
          }
          image_left {
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 542)
              }
            }
          }
          image_right {
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 542)
              }
            }
          }
        }

        cta {
          title
          upss {
            item
          }
          persons {
            person {
              image {
                localFile {
                  childImageSharp {
                    fluid(quality: 100, maxWidth: 300) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
              description
            }
            button {
              title
              url
            }
          }
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 601) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }

        identity {
          title
          description
          usp {
            title
            description
          }
          background_description
        }

        download_brochure {
          backroundtext
          description
          form_id
          image_brochure {
            localFile {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 1100)
              }
            }
          }
        }

        contact {
          title
          form_id
          contactdetails
        }

        maps {
          backgroundtekst
          image {
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(quality: 100, width: 2000)
              }
            }
          }
        }
      }

      yoast_meta {
        name
        content
        property
      }
    }
  }
`
